import React from 'react';
import Loading from '../../collection/icons/Loading';
import TableHandler from '../../collection/TableHandler';
import CalendarFilter from '../../components/filters/CalendarFilter';
import Calendar from '../../components/project/Calendar';
import { apiForm, getSession } from '../../utils/api';
import { generateFormData } from '../../utils/functions';
import './Calendario.scss';

export default function Calendario(props) {
    // default filter
    const usuario = getSession();
    const isSuper = props.super;
    const isAdmin = usuario.permisoAdmin || usuario.permisoValidacion;
    const defaultFilter = {
        trabajador: isSuper ? null : usuario.id,
        pendiente: false,
        validado: true
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("calendario/get", filter);
    }

    // render
    return <div className={props.className}>
        {isSuper && <h2>Calendario de ausencias</h2>}
        <TableHandler onUpdate={updateData}>
            {isSuper && <CalendarFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectDepartamento={isSuper}
                selectTrabajador={isSuper}
                selectEstado={isAdmin} />}
            {isSuper && <div className="d-flex gap-2 justify-content-center mb-3">
                <Leyenda color="DarkGrey">Festivo</Leyenda>
                <Leyenda color="SlateGray">Festivo local</Leyenda>
                <Leyenda color="LightSeaGreen">Vacaciones</Leyenda>
                {isAdmin && <Leyenda color="Orange">Baja</Leyenda>}
                <Leyenda color="DeepSkyBlue">Permiso</Leyenda>
                <Leyenda color="#bd6268">Día convenio</Leyenda>
                <Leyenda color="#626d5f">Día libre</Leyenda>
            </div>
            }
            <CalendarioView super={props.super} />
        </TableHandler>
    </div>;
}

const CalendarioView = props => props.data ? <Calendar events={props.data} /> : <Loading />;
const Leyenda = props => <span style={{ backgroundColor: props.color }} className="leyenda">{props.children}</span>;
